// tslint:disable:max-line-length

import React from 'react';

export const OperatorDivide = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M4.42,8.16V6.38h7.17V8.16ZM7.05,5.4V3.73H8.94V5.4Zm0,5.44V9.17H8.94v1.67Z" />
    </svg>
  );
};
